<template>
  <div class="bg">
    <banner-top :text="titletext"></banner-top>
    <div class="bg"></div>
    <div class="main">
        <div class="frist">
            <div>名称：{{res.order_detail.lecture.title}}</div>
            <div>日期：{{res.order_detail.day}}</div>
            <div>时间：{{res.order_detail.session.start}}-{{res.order_detail.session.end}}</div>
            <div>地点：{{res.order_detail.place.address}}</div>
        </div>
        <div class="second" v-for="item in res.order_detail.students.slice(0,res.order_detail.students.length-1)" :key="item.id">
            <div class="name">{{item.name}}</div>
            <div>学校：{{item.school}}</div>
            <div>班级：{{item.classroom}}</div>
            <div>性别: {{item.gender==2?'女':'男'}}</div>
            <div>身份证号：{{item.id_no}}</div>
            <div>联系电话：{{item.phone}}</div>
        </div>
        <div class="second-other">
            <div class="name">{{res.order_detail.students[res.order_detail.students.length-1].name}}</div>
            <div>学校：{{res.order_detail.students[res.order_detail.students.length-1].school}}</div>
            <div>班级：{{res.order_detail.students[res.order_detail.students.length-1].classroom}}</div>
            <div>性别:{{res.order_detail.students[res.order_detail.students.length-1].gender==2?'女':'男'}}</div>
            <div>身份证号：{{res.order_detail.students[res.order_detail.students.length-1].id_no}}</div>
            <div>联系电话：{{res.order_detail.students[res.order_detail.students.length-1].phone}}</div>
        </div>
        <div class="last">
            <div>订单号：{{res.order_no}}</div>
            <div>创建时间：{{res.created}}</div>
        </div>
    </div>
    <!-- <div class="nav">
        <button>保存报名信息</button>
    </div> -->
  </div>
</template>

<script>
import bannerTop from '../components/BannerTop.vue'
import http from '../utils/http'

export default {
  name: 'registration',
  components: { bannerTop },
  data () {
    return {
      titletext: '报名表详情',
      res: Object
    }
  },
  created () {
    http['get'](`orders/${this.$route.query.order_no}`).then((res) => {
      this.res = res
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bg {
    position: absolute;
    width: 100%;
    background: #f5f5f5;
    z-index: -1;
}
.main {
    width: 90%;
    margin: 5%;
    background: #fff;
    border-radius: 1rem;
}
.frist {
    background: #ffb949;
    padding: 1rem;
    border-top-left-radius: 1rem;
    border-top-right-radius: 1rem;
}
.second {
    width: 90%;
    margin: 1rem;
    border-bottom: 1px #999 dashed;
    padding-bottom: 1rem;
    color: #666;
}
.none {
    border: 0!important;
}
.name {
    color: #000;
    font-size: 17px;
}
.second-other {
  width: 90%;
  margin: 1rem;
  padding-bottom: 1rem;
  color: #666;
}
.last {
    border-bottom-left-radius: 1rem;
    border-bottom-right-radius: 1rem;
    background: #e6e6e6;
    display: flex;
    padding: 1rem 1rem;
    flex-direction: column;
    justify-content: center;
    /* align-items: center; */
    margin-top: -1rem;
    text-align: left;
}
.nav {
  width: 100%;
  margin: 1rem 0;
  display: flex;
  justify-content: center;
}
.nav button {
    width: 80%;
    height: 2.8rem;
    background: #ffb949;
    border-radius: 44px;
    border: 0;
    color: #fff;
    font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/mine/registration.vue